import type React from 'react'
import type { SelectActionsProps } from '../../select.types'

export const SelectActions: React.FC<SelectActionsProps> = ({ children }) => {
  return (
    <div className="input-select-actions" data-testid="input-name-actions">
      {children}
    </div>
  )
}
